import Vue from 'vue'
import Vuex from 'vuex'
import config from './config/.active.config.json';
import countries from './data/countries.json';
import account_types from './data/account_types.json';
import i18n from './i18n'
import Cookies from "js-cookie";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {},
  state: {
    dashboard_data: {},
    logged_in: false,
    showCookieModal: false,
    token: null,
    refresh_token: null,
    transfer_amount: null,
    boleto_details: null,
    config: config,
    country_dropdown: null,
    bank_dropdown: null,
    branch_dropdown: null,
    account_type_dropdown: null,
    doing_transfer: false,
    doing_bill_payment: false,
    user_data: null,
    active_language: 'br',
    active_tfa: false,
    window_size: {
      width: 0,
      height: 0
    },
    bar_minimized: false,
  },
  mutations: {
    doing_personal_transfer: (state, status) => {
      state.doing_transfer = status
    },
    doing_bill_payment: (state, status) => {
      state.doing_bill_payment = status
    },
    boleto_details: (state, status) => {
      state.boleto_details = status
    },
    country_dropdown: (state, status) => {
      state.country_dropdown = status
    },
    bank_dropdown: (state, status) => {
      state.bank_dropdown = status
    },
    branch_dropdown: (state, status) => {
      state.branch_dropdown = status
    },
    account_type_dropdown: (state, status) => {
      state.account_type_dropdown = status
    },
    transfer_amounts: (state, status) => {
      state.transfer_amount = status
    },
    is_logged_in: (state, status) => {
      state.logged_in = status
    },
    set_token: (state, status) => {
      state.token = status
    },
    set_refresh_token: (state, status) => {
      state.refresh_token = status
    },
    set_user_data: (state, data) => {
      state.user_data = data
    },
    set_active_language: (state, data) => {
      state.active_language = data
    },
    set_active_tfa: (state, data) => {
      state.active_tfa = data
    },
    set_window_size: (state, data) => {
      state.window_size = data
    },
    set_bar_minimized: (state, data) => {
      state.bar_minimized = data
    },
    toggle_sidebar: (state, data) => {
      state.bar_minimized = !state.bar_minimized
    },
    set_dashboard_data: (state, data) => {
      state.dashboard_data = data
    },
    set_dashboard_data_key: (state, data) => {
      state.dashboard_data[data.key] = data.data;
    },
    set_show_cookie_modal: (state, data) => {
      state.showCookieModal = data
    },
  },
  actions: {
    SetDoingPersonalTransferStatus: (state, status) => {
      state.commit('doing_personal_transfer', status);
    },
    SetPayingBillStatus: (state, status) => {
      state.commit('doing_bill_payment', status);
    },
    SetBoletoDetails: (state, status) => {
      state.commit('boleto_details', status);
    },
    SetCountryDropDown: (state, data) => {
      state.commit('country_dropdown', data);
    },
    SetBankDropDown: (state, status) => {
      state.commit('bank_dropdown', status);
    },
    SetBranchDropDown: (state, status) => {
      state.commit('branch_dropdown', status);
    },
    SetAccountTypeDropDown: (state, status) => {
      state.commit('account_type_dropdown', status);
    },
    SetTransferAmounts: (state, status) => {
      state.commit('transfer_amounts', status);
    },
    SetLoggedIn: (state, loggedIn) => {
      if (!loggedIn) {
        Cookies.remove("token");
        Cookies.remove("refresh_token");
      }
      state.commit('is_logged_in', loggedIn);
    },
    SetToken: (state, data) => {
      if (data.refresh_token) {
        const in1Day = new Date(new Date().getTime() + 3600 * 23 * 1000);
        Cookies.set("refresh_token", data.refresh_token, {expires: in1Day, sameSite: 'strict'});
      }
      if (data.token) {
        const in50Minutes = new Date(new Date().getTime() + 50 * 60 * 1000);
        Cookies.set("token", data.token, {expires: in50Minutes, sameSite: 'strict'});
      }
      state.commit('set_token', data.token);
      state.commit('set_refresh_token', data.refresh_token);
    },
    SetUserData: (state, data) => {
      state.commit('set_user_data', data);
    },
    SetActiveLanguage: (state, data) => {

      let language = data;
      const dropdown = countries;

      if (language === 'br') {
        language = 'pt';
      }

      const dropDownData = dropdown.map(country => {
        return {name: country[language], code: country.code, flag: country.flag, phoneCode: country.phone};
      })

      const accountTypeData = account_types[language].map(account => {
        return {id: account.id, type: account.type}
      })

      Cookies.set("language", data, {expires: 120, sameSite: 'strict'});

      state.commit('country_dropdown', dropDownData);
      state.commit('account_type_dropdown', accountTypeData);
      state.commit('set_active_language', data);
      i18n.locale = data;
    },
    SetActiveTfa: (state, status) => {
      state.commit('set_active_tfa', status);
    },
    SetWindowSize: (state, data) => {
      state.commit('set_window_size', data);
    },
    SetBarMinimized: (state, data) => {
      state.commit('set_bar_minimized', data);
    },
    ToggleSideBar: (state, data) => {
      state.commit('toggle_sidebar', data);
    },
    SetDashBoardData: (state, data) => {
      state.commit('set_dashboard_data', data);
    },
    SetDashBoardDataKey: (state, data) => {
      state.commit('set_dashboard_data_key', data);
    },
    SetCookieModalDisplay: (state, data) => {
      state.commit('set_show_cookie_modal', data);
    },
  },
  getters: {
    GetDoingPersonalTransferStatus: state => {
      return state.doing_transfer;
    },
    GetPayingBillStatus: state => {
      return state.doing_bill_payment;
    },
    GetConfig: state => {
      return state.config;
    },
    GetCountryDropDown: state => {
      return state.country_dropdown;
    },
    GetBankDropDown: state => {
      return state.bank_dropdown;
    },
    GetBranchDropDown: state => {
      return state.branch_dropdown;
    },
    GetAccountTypeDropDown: state => {
      return state.account_type_dropdown;
    },
    GetTransferAmounts: state => {
      return state.transfer_amount;
    },
    GetBoletoDetails: state => {
      return state.boleto_details;
    },
    GetLoggedIn: state => {
      return state.logged_in;
    },
    GetToken: state => {
      return state.token;
    },
    GetRefreshToken: state => {
      return state.refresh_token;
    },
    GetUserData: state => {
      return state.user_data;
    },
    GetActiveLanguage: state => {
      return state.active_language;
    },
    GetActiveTfa: state => {
      return state.active_tfa;
    },
    GetWindowSize: state => {
      return state.window_size;
    },
    GetDashboardData: state => {
      return state.dashboard_data;
    },
    GetCookieModal: state => {
      return state.showCookieModal;
    },
    GetBarMinimized: state => {
      if (!state.bar_minimized) {
        return state.window_size.width < 1024;
      } else {
        return true
      }
    },
  }
});
